import {Alert} from 'antd';

const AccessDeniedAlert = () => (
  <Alert
    message="Error"
    description="Permission denied."
    type="error"
    showIcon
  />
);

export default AccessDeniedAlert;
